/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PriceAlertDirectionEnum,
    PriceAlertDirectionEnumFromJSON,
    PriceAlertDirectionEnumFromJSONTyped,
    PriceAlertDirectionEnumToJSON,
} from './PriceAlertDirectionEnum';

/**
 * 
 * @export
 * @interface SymbolPriceAlertDto
 */
export interface SymbolPriceAlertDto {
    /**
     * 
     * @type {PriceAlertDirectionEnum}
     * @memberof SymbolPriceAlertDto
     */
    direction: PriceAlertDirectionEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SymbolPriceAlertDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolPriceAlertDto
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolPriceAlertDto
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolPriceAlertDto
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolPriceAlertDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SymbolPriceAlertDto
     */
    currentPrice: number;
    /**
     * 
     * @type {number}
     * @memberof SymbolPriceAlertDto
     */
    targetPrice: number;
    /**
     * 
     * @type {string}
     * @memberof SymbolPriceAlertDto
     */
    symbolId: string;
}

export function SymbolPriceAlertDtoFromJSON(json: any): SymbolPriceAlertDto {
    return SymbolPriceAlertDtoFromJSONTyped(json, false);
}

export function SymbolPriceAlertDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolPriceAlertDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'direction': PriceAlertDirectionEnumFromJSON(json['direction']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'id': json['id'],
        'currentPrice': json['currentPrice'],
        'targetPrice': json['targetPrice'],
        'symbolId': json['symbolId'],
    };
}

export function SymbolPriceAlertDtoToJSON(value?: SymbolPriceAlertDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'direction': PriceAlertDirectionEnumToJSON(value.direction),
        'email': value.email,
        'fullName': value.fullName,
        'symbol': value.symbol,
        'currency': value.currency,
        'id': value.id,
        'currentPrice': value.currentPrice,
        'targetPrice': value.targetPrice,
        'symbolId': value.symbolId,
    };
}

